export default __webpack_public_path__ + "static/media/cuapts-bear.02937455.png";